import ProcessingClient from '@/services/clients/processing';
import { UserGroup } from '@/types';

export default {
    namespaced: true,
    state: {
        user: {},
    },
    getters: {
        user: state => state.user,
        isCorporateUser: state => state.user.userGroup === UserGroup.CORPORATE,
        isAllowWebWalletsByUserCountry: state => state.user.allowWebWalletsByUserCountry,
        fullName: state => [state.user.firstName, state.user.lastName].filter(el => el).join(' '),
    },
    mutations: {
        setUser(state, payload) {
            state.user = payload;
        },
    },
    actions: {
        async fetchUser({ commit }) {
            const user =  await ProcessingClient.getUser();
            return commit('setUser', user);
        },
    }
};
